import { render, staticRenderFns } from "./Lgx02654690235314836865804.vue?vue&type=template&id=2ab50194&"
import script from "./Lgx02654690235314836865804.vue?vue&type=script&lang=js&"
export * from "./Lgx02654690235314836865804.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports